import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class IndustryTypePage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { industryTypePage,currentIndustryType} = this.props.system;
     this.fetchList( industryTypePage);
  }

  fetchList = (page,values) => {
    const {getIndustryTypeList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getIndustryTypeList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { industryTypeById, industryTypeList } = system;
    if (!industryTypeList) return [];
    return industryTypeList.map(id => industryTypeById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getIndustryTypeListPending,industryTypeTotal,industryTypePage } = system
    const { deleteIndustryType,chooseCurrentIndustryType,industryTypeModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getIndustryTypeListPending,
      columns:[
        {
          title: "行业名",
          dataIndex: 'industryName',
          key: 'industryName',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:industryTypeTotal,
        current:industryTypePage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentIndustryType(record);
          industryTypeModalChange(true,"updata");
        }else if(item.key == 3){
            deleteIndustryType(record.id).then((data) => {
            this.fetchList(industryTypePage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentIndustryType, industryTypeModalVisible,industryTypePage, industryTypeModalType,submitIndustryTypePending } = system

    const { industryTypeModalChange,submitIndustryType } = actions;
    const editItem  = industryTypeModalType === 'create' ? {} : currentIndustryType
    return {
      item: industryTypeModalType === 'create' ? {} : currentIndustryType,
      visible: industryTypeModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitIndustryTypePending,
      title: `${
        industryTypeModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "industryName",
          label: "行业名",
          initialValue: editItem.industryName,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitIndustryType(Object.assign({},data,{})).then(data=> {
          industryTypeModalChange(false,"create");
          this.fetchList(industryTypePage);
        })
      },
      onCancel() {
        industryTypeModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentIndustryType,industryTypePage} = system
    const { industryTypeModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "industryName",
            widget: Input,
            widgetProps:{
                placeholder:"请输入行业类型名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        industryTypeModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentIndustryType,industryTypePage} = system
    const { industryTypeModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ industryTypeModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        {/* <CrudFilter {...this.filterProps} /> */}
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndustryTypePage);


// WEBPACK FOOTER //
// ./src/features/system/IndustryTypePage.js